import { tv, type VariantProps } from 'tailwind-variants';

export const inputControl = tv({
  base: [
    'flex flex-1 px-4 py-0.5 outline-none',
    'disabled:cursor-not-allowed disabled:opacity-40',
  ],

  variants: {
    variant: {
      'network-flush': [
        'focus:border-network-primary border-b border-gray-50 focus:border-b-2',
      ],
      ghost: '',
    },
  },

  defaultVariants: {
    variant: 'ghost',
  },
});

export type InputVariantProps = VariantProps<typeof inputControl>;
